export function asCurrency(value, currency = 'USD') {
  if (value === null || value === undefined || value === '') return '—';
  const number = Number(value);
  if (!Number.isFinite(number)) return String(value);
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(number / (Math.abs(number) > 10000 ? 100 : 1));
}

export function asCount(value) {
  if (value === null || value === undefined || value === '') return '0';
  return new Intl.NumberFormat('en-US').format(Number(value) || 0);
}

export function titleize(value) {
  return String(value || 'unknown').replace(/[_-]+/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function truncateMiddle(value, size = 12) {
  const text = String(value || '');
  if (text.length <= size * 2 + 3) return text;
  return `${text.slice(0, size)}…${text.slice(-size)}`;
}

export function safeArray(value) {
  return Array.isArray(value) ? value : [];
}
